<!--
| Ini adalah component root dari halaman Dashboard Klien.
| Hampir semua data di get-nya dari sini lalu diparsing ke komponen childnya.
|
| @author   : Ronaldo Simanjuntak
| @company  : PT Kabayan Aishwarya Nusantara
| @app      : Online Media Monitoring
| @version  : 3.0.0
-->

<template>
  <div id="dashboard-page">
    <page-header-component v-if="topics" :topics="topics" :hideValidate="false" icon="bi bi-speedometer"
      title="Beranda" />
    <!-- <div>
      <p><input type="text" v-model="coba" placeholder="judul artikel" /></p>
    </div> -->
    <transition name="block">
      <div class="mt-4">
        <score-card-component v-if="display_tipe == 3" :data="card" :isloading="is_loading" />
        <medkon-score-card-component v-else-if="display_tipe == 2" :data="data_scorecard_medkon"
          :isloading="is_loading" />
        <medsos-score-card-component v-else-if="display_tipe == 1" :stats="data_scorecard_medsos"
          :isLoading="is_loading" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="mt-3">
        <medsos-tren-mention-component v-if="display_tipe == 1" :key="sources_key"
          :data_line_chart="data_tren_medsos_kurasi" :data_source="sources_medsos" :is-loading="is_loading" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="mt-4">
        <medsos-sentiment-post-component v-if="display_tipe == 1" :key="g_topik_key" :data_grafik="data_topik_medsos" />
      </div>
    </transition>

    <transition name="block">
      <div class="mt-4">
        <tren-medkon-medsos-component v-if="display_tipe == 3" :data="data_tren_grafik" :isloading="is_loading" />
        <medkon-tren-media-konvensional-component v-else-if="display_tipe == 2" :data="data_tren_grafik"
          :isloading="is_loading" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="row mt-4">
        <source-post-count-component v-if="display_tipe == 3" :data="data_count_source" :isloading="is_loading"
          :is_mobile="is_mobile" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="mt-4">
        <news-trend-component class="p-l-5 p-r-5" v-if="news_trend > 0" :data="data_newstrend" :barData="barData"
          :key="newstrendKey" :is_loading="is_loading" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="mt-4">
        <sentiment-post-component v-if="display_tipe == 3" :data="dashboard_data_sentimen" :is_loading="is_loading"
          :is_mobile="is_mobile" :display_tipe="display_tipe" />
        <medkon-sentiment-post-component v-else-if="display_tipe == 2" :data="dashboard_data_sentimen"
          :is_loading="is_loading" :is_mobile="is_mobile" :topik_toggle="topik_toggle" :sentimen_toggle="sentimen_toggle"
          :display_tipe="display_tipe" />
      </div>
    </transition>

    <transition name="block">
      <div v-show="mounted" class="row mt-4">
        <post-list-component v-if="display_tipe == 3" :data_tab_formed="data_tab_formed"
          :data_tab_medsos="data_tab_medsos" :display_tipe="display_tipe" />
        <medkon-post-list-component v-else-if="display_tipe == 2" :data="data_tab_formed" />
      </div>
    </transition>

    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }" />
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import page_header from "@/views/components/page_header.vue";
import carousel_post_list from "@/views/components/dashboard/carousel_post_list.vue";
import gp from "@/plugins/generalPlugins.js";
import moment from "moment";
import { isMobile } from "mobile-device-detect";
import score_card from "@/views/components/dashboard/score_card.vue";
import medkon_score_card from "@/views/components/dashboard/medkon_score_card.vue";
import tren_medkon_medsos from "@/views/components/dashboard/tren_medkon_medsos.vue";
import medkon_tren_media_konvensional from "@/views/components/dashboard/medkon_tren_media_konvensional.vue";
import source_post_count from "@/views/components/dashboard/source_post_count.vue";
import sentiment_post from "@/views/components/dashboard/sentiment_post.vue";
import medkon_sentiment_post from "@/views/components/dashboard/medkon_sentiment_post.vue";
import post_list from "@/views/components/dashboard/post_list.vue";
import medkon_post_list from "@/views/components/dashboard/medkon_post_list.vue";
import news_trend from "@/views/components/dashboard/news_trend.vue";
import medsos_score_card from "@/views/components/dashboard/medsos_score_card.vue";
import medsos_tren_mention from "@/views/components/dashboard/medsos_tren_mention.vue";
import medsos_sentiment_post from "@/views/components/dashboard/medsos_sentiment_post.vue";

var data_table_config = {
  lengthChange: false,
  pageLength: 5,
  columnDefs: [{ width: "30%", targets: 0 }],
};
var table_header = [
  "Topik",
  "Sentimen Positif",
  "Sentimen Netral",
  "Sentimen Negatif",
];
var data_tab_formed = [
  {
    name: "Terpopuler",
    icon_class: "bi bi-chat-fill text-blue",
    component: carousel_post_list,
    data: [{ sort: "esmr", is_socmed: false, id: "popular-formed" }],
  },
  {
    name: "Terbaru",
    icon_class: "bi bi-calendar-event text-blue",
    component: carousel_post_list,
    data: [{ sort: "date", is_socmed: false, id: "terbaru-formed" }],
  },
  {
    name: "Sorotan",
    icon_class: "bi bi-star-fill text-blue",
    component: carousel_post_list,
    data: [
      {
        sort: "esmr",
        is_socmed: false,
        is_highlight: true,
        id: "highlight-formed",
      },
    ],
  },
];
var data_tab_medsos = [
  {
    name: "Terpopuler",
    icon_class: "bi bi-chat-fill text-blue",
    component: carousel_post_list,
    data: [{ sort: "esmr", is_socmed: true, id: "popular-sosmed" }],
  },
  {
    name: "Terbaru",
    icon_class: "bi bi-calendar-event text-blue",
    component: carousel_post_list,
    data: [{ sort: "date", is_socmed: true, id: "terbaru-sosmed" }],
  },
  {
    name: "Sorotan",
    icon_class: "bi bi-star-fill text-blue",
    component: carousel_post_list,
    data: [
      {
        sort: "esmr",
        is_socmed: true,
        is_highlight: true,
        id: "highlight-sosmed",
      },
    ],
  },
  {
    name: "Keterlibatan",
    icon_class: "bi bi-share-fill text-blue",
    component: carousel_post_list,
    data: [{ sort: "engagement", is_socmed: true, id: "engagement-sosmed" }],
  },
];

export default {
  name: "Dashboard",
  title: "Beranda | Sibernetik",
  components: {
    "page-header-component": page_header,
    "score-card-component": score_card,
    "medkon-score-card-component": medkon_score_card,
    "medsos-score-card-component": medsos_score_card,
    "tren-medkon-medsos-component": tren_medkon_medsos,
    "medkon-tren-media-konvensional-component": medkon_tren_media_konvensional,
    "source-post-count-component": source_post_count,
    "sentiment-post-component": sentiment_post,
    "medkon-sentiment-post-component": medkon_sentiment_post,
    "post-list-component": post_list,
    "medkon-post-list-component": medkon_post_list,
    "news-trend-component": news_trend,
    "medsos-tren-mention-component": medsos_tren_mention,
    "medsos-sentiment-post-component": medsos_sentiment_post,
  },
  data() {
    return {
      // coba: this.$store.getters.user.role,
      is_loading: true,
      is_mobile: isMobile,
      sentimen_toggle:
        this.$store.getters.user.project.project_detail.display_tipe == 3 ||
          this.$store.getters.user.project.project_detail.display_tipe == 2
          ? "medkon"
          : "medsos",
      topik_toggle:
        this.$store.getters.user.project.project_detail.display_tipe == 3 ||
          this.$store.getters.user.project.project_detail.display_tipe == 2
          ? "medkon"
          : "medsos",
      query: null,
      card: null,
      data_tren_formed: null,
      data_tren_medsos: null,
      data_source_list_formed: [],
      data_source_list: [],
      data_sentimen_key: 10,
      data_sentimen_current: null,
      data_sentimen: null,
      data_sentimen_formed: null,
      data_sentimen_persentase: null,
      data_sentimen_persentase_formed: {
        positif: 0,
        netral: 0,
        negatif: 0,
      },
      data_topik: null,
      data_topik_barchart: null,
      data_topik_barchart_formed: null,
      data_topik_barchart_current: null,
      data_topik_key: 0,
      dt_key: 20,
      dt_head: table_header,
      dt_body_current: null,
      dt_body: null,
      dt_body_formed: null,
      dt_config: data_table_config,
      data_tab_formed: data_tab_formed,
      data_tab_medsos: data_tab_medsos,
      mounted: false,
      id_project: this.$store.getters.user.id_project,
      event_linechart_medkon: {},
      event_linechart_medsos: {},
      show_tren_reach: false,
      data_tren_reach: null,
      topics: null,
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      tour_steps: [],
      barchart_drilldown: {},
      barchart_drilldown_key: 30,
      data_scorecard_medkon: {},
      data_scorecard_medsos: {},
      data_tren_grafik: {},
      data_count_source: {},
      dashboard_data_sentimen: {},
      dashboard_data_post: {},
      news_trend: this.$store.getters.user.project.project_detail.news_trend,
      sources_medsos: [],
      sources_key: 0,
      data_tren_medsos_kurasi: null,
      data_topik_medsos: null,
      g_topik_key: 0,
      reachKey: 0,
      data_newstrend: [],
      barData: {},
      newstrendKey: 90,
      activeChannel: null,
    };
  },
  methods: {
    getData: function () {
      var params = this.$route.query;
      let self = this;
      let query;
      let path =
        this.display_tipe == 2 || this.display_tipe == 3
          ? "dashboard"
          : "dashboard-classic";

      if ("sources" in params) {
        delete params.sources;
      }
      if ("from" in params && "to" in params) {
        query = Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
      }

      if (this.query != query) {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          path +
          "/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then((response) => {
            this.data_sentimen = null;
            this.data_sentimen_formed = null;
            this.data_topik_barchart = null;
            this.data_topik_barchart_formed = null;
            this.data_topik_barchart_current = null;
            this.data_tren_reach = null;
            this.data_tren_medsos = null;
            this.data_tren_formed = null;

            if (response.status == 200) {
              if (this.display_tipe == 2 || this.display_tipe == 3) {
                this.card = {
                  formed: response.data.stats_formed.total,
                  medsos: response.data.stats.total,
                  engagement: response.data.stats.engagement
                    ? response.data.stats.engagement
                    : 0,
                  reach: response.data.stats.esmr
                    ? response.data.stats.esmr
                    : 0,
                };

                this.data_tren_formed = {
                  y: [
                    {
                      color: this.$channel_color["news"],
                      name: "Media Online",
                      data: response.data.trend_formed.news
                    },
                    {
                      color: "#e83e8c",
                      name: "Media TV",
                      data: response.data.trend_formed.media_tv,
                    },
                    {
                      color: "#6c757d",
                      name: "Media Cetak",
                      data: response.data.trend_formed.media_cetak,
                    },
                  ],
                  x: response.data.trend_formed.date,
                  yAxis: ["Jumlah Media Online", "Jumlah Media Online"],
                };

                let self = this;
                this.event_linechart_medkon = {
                  click: function () {
                    // const sources = event.point.series.name;
                    let start = "";
                    let end = "";
                    let start_obj;
                    let end_obj;
                    let params = {};
                    let tgl = this.category.split(" ");
                    let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];

                    if (moment(tgl_str, "YYYY-MMM-DD").isValid()) {
                      start_obj = moment(tgl_str, "YYYY-MMM-DD");
                      start = start_obj.format("YYYY-MM-DD 00:00:00");
                      end_obj = start_obj;
                      end = start_obj.format("YYYY-MM-DD 23:59:59");
                    } else {
                      let tgl = self.$route.query.from;
                      start_obj = moment(tgl, "YYYY-MM-DD HH:mm:ss");
                      end_obj = moment(tgl, "YYYY-MM-DD HH:mm:ss");
                      start = start_obj.format("YYYY-MM-DD HH:mm:ss");
                      end = moment(self.$route.query.to).format(
                        "YYYY-MM-DD HH:mm:ss"
                      );
                    }

                    self.$store.dispatch("set_date_filter", {
                      from: start_obj,
                      to: end_obj,
                    });

                    let source_selected = "news";
                    // let source_selected;
                    // if (sources == "Online News") {
                    //   source_selected = "news";
                    // } else if (sources == "Media Cetak") {
                    //   source_selected = "media_cetak";
                    // } else {
                    //   source_selected = "media_tv";
                    // }

                    params = {
                      from: start,
                      to: end,
                      sources: btoa(source_selected),
                    };

                    if ("topic" in self.$route.query) {
                      params.topic = self.$route.query.topic;
                    }

                    self.$router.push({ path: "/posts", query: params });
                  },
                };

                this.data_tren_reach = {
                  y: [
                    {
                      color: this.$channel_color["mention"],
                      name: "Mentions",
                      data: response.data.trend.mention,
                    },
                    {
                      color: this.$channel_color["engagement"],
                      name: "Keterlibatan",
                      data: response.data.trend.engagement,
                      yAxis: 1,
                      visible: false,
                    },
                    {
                      color: this.$channel_color["reach"],
                      name: "Jangkauan",
                      data: response.data.trend.reach,
                      yAxis: 1,
                    },
                  ],
                  x: response.data.trend_formed.date,
                };
                this.event_linechart_medsos = {
                  click: function () {
                    // const sources = event.point.series.name;
                    let start = "";
                    let end = "";
                    let start_obj;
                    let end_obj;
                    let params = {};
                    let tgl = this.category.split(" ");
                    let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];

                    if (moment(tgl_str, "YYYY-MMM-DD").isValid()) {
                      start_obj = moment(tgl_str, "YYYY-MMM-DD");
                      start = start_obj.format("YYYY-MM-DD 00:00:00");
                      end_obj = start_obj;
                      end = start_obj.format("YYYY-MM-DD 23:59:59");
                    } else {
                      let tgl = self.$route.query.from;
                      start_obj = moment(tgl, "YYYY-MM-DD HH:mm:ss");
                      end_obj = moment(tgl, "YYYY-MM-DD HH:mm:ss");
                      start = start_obj.format("YYYY-MM-DD HH:mm:ss");
                      end = moment(self.$route.query.to).format(
                        "YYYY-MM-DD HH:mm:ss"
                      );
                    }

                    self.$store.dispatch("set_date_filter", {
                      from: start_obj,
                      to: end_obj,
                    });
                    let source_selected = [
                      'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                    ];
                    // let source_selected;
                    // if (sources == "Review Aplikasi") {
                    //   source_selected = "review";
                    // } else {
                    //   source_selected = sources.toLowerCase();
                    // }
                    params = {
                      from: start,
                      to: end,
                      sources: btoa(source_selected),
                    };

                    if ("topic_selected" in self.$route.query) {
                      params.topic_selected = self.$route.query.topic_selected;
                    }
                    if ("cakupan" in self.$route.query) {
                      params.cakupan = self.$route.query.cakupan;
                    }

                    self.$router.push({ path: "/posts", query: params });
                  },
                };

                let data_series_trend_sosmed = [];
                for (let v_source in response.data.trend_source) {
                  if (v_source != "date") {
                    let jml_kata = v_source.split(" ");
                    let legend_item = "";
                    if (jml_kata.length > 1) {
                      for (let w in jml_kata) {
                        if (w == jml_kata.length - 1) {
                          legend_item +=
                            jml_kata[w].charAt(0).toUpperCase() +
                            jml_kata[w].slice(1);
                        } else {
                          legend_item +=
                            jml_kata[w].charAt(0).toUpperCase() +
                            jml_kata[w].slice(1) +
                            " ";
                        }
                      }
                    } else {
                      legend_item =
                        v_source.charAt(0).toUpperCase() + v_source.slice(1);
                    }
                    data_series_trend_sosmed.push({
                      name: v_source == "news" ? "Online News" : legend_item,
                      data: response.data.trend_source[v_source],
                      color: this.$channel_color[v_source],
                    });
                  }
                }
                this.data_tren_medsos = {
                  y: data_series_trend_sosmed,
                  x: response.data.trend_source.date,
                };
                // MEDIA ONLINE
                this.data_source_list_formed = [];

                if ("formed" in this.activeChannel) {
                  if (this.activeChannel.formed.tv_status == 1) {
                    this.data_source_list_formed.push({
                      id: "media_tv",
                      icon: '<i class="bi bi-tv icon-media-tv"></i>',
                      name: "Media TV",
                      value: gp.kmbFormatter(
                        response.data.stats_formed.media_tv
                      ),
                    });
                  }
                }
                if ("formed" in this.activeChannel) {
                  if (this.activeChannel.formed.cetak_status == 1) {
                    this.data_source_list_formed.push({
                      id: "media_cetak",
                      icon: '<i class="bi bi-newspaper icon-media-cetak"></i>',
                      name: "Media Cetak",
                      value: gp.kmbFormatter(
                        response.data.stats_formed.media_cetak
                      ),
                    });
                  }
                }
                if ("google" in this.activeChannel) {
                  if (this.activeChannel.google.news_status == 1) {
                    this.data_source_list_formed.push({
                      id: "news",
                      icon: '<i class="bi bi-globe-americas icon-news"></i>',
                      name: "Media Online",
                      value: response.data.stats_formed.news
                        ? gp.kmbFormatter(response.data.stats_formed.news)
                        : 0,
                    });
                  }
                }

                // MEDIA SOSIAL
                this.data_source_list = [];
                if ("facebook" in this.activeChannel) {
                  if (this.activeChannel.facebook.status == 1) {
                    this.data_source_list.push({
                      id: "facebook",
                      icon: '<i class="bi bi-facebook"></i>',
                      name: "Facebook",
                      value: gp.kmbFormatter(response.data.stats.facebook),
                    });
                  }
                }
                if ("twitter" in this.activeChannel) {
                  if (this.activeChannel.twitter.status == 1) {
                    this.data_source_list.push({
                      id: "twitter",
                      icon: '<i class="bi bi-twitter-x"></i>',
                      name: "Twitter",
                      value: gp.kmbFormatter(response.data.stats.twitter),
                    });
                  }
                }
                if ("instagram" in this.activeChannel) {
                  if (this.activeChannel.instagram.status == 1) {
                    this.data_source_list.push({
                      id: "instagram",
                      icon: '<i class="bi bi-instagram"></i>',
                      name: "Instagram",
                      value: gp.kmbFormatter(response.data.stats.instagram),
                    });
                  }
                }
                if ("tiktok" in this.activeChannel) {
                  if (this.activeChannel.tiktok.status == 1) {
                    this.data_source_list.push({
                      id: "tiktok",
                      icon: '<i class="bi bi-tiktok"></i>',
                      name: "Tiktok",
                      value: gp.kmbFormatter(response.data.stats.tiktok),
                    });
                  }
                }
                if ("youtube" in this.activeChannel) {
                  if (this.activeChannel.youtube.status == 1) {
                    this.data_source_list.push({
                      id: "youtube",
                      icon: '<i class="bi bi-youtube"></i>',
                      name: "Youtube",
                      value: gp.kmbFormatter(response.data.stats.youtube),
                    });
                  }
                }
                if ("linkedin" in this.activeChannel) {
                  if (this.activeChannel.linkedin.status == 1) {
                    this.data_source_list.push({
                      id: "linkedin",
                      icon: '<i class="bi bi-linkedin"></i>',
                      name: "Linkedin",
                      value: gp.kmbFormatter(response.data.stats.linkedin),
                    });
                  }
                }
                // if ("google" in this.activeChannel) {
                //   if (this.activeChannel.google.blog_status == 1) {
                //     this.data_source_list.push({
                //       id: "blog",
                //       icon: '<i class="bi bi-rss"></i>',
                //       name: "Blog",
                //       value: gp.kmbFormatter(response.data.stats.blog),
                //     });
                //   }
                // }
                if ("google" in this.activeChannel) {
                  if (this.activeChannel.google.forum_status == 1) {
                    this.data_source_list.push({
                      id: "forum",
                      icon: '<i class="bi bi-chat-dots-fill"></i>',
                      name: "Forum",
                      value: gp.kmbFormatter(response.data.stats.forum),
                    });
                  }
                }
                // if ("review" in this.activeChannel) {
                //   if (this.activeChannel.review.status == 1) {
                //     this.data_source_list.push({
                //       id: "review",
                //       icon: '<i class="bi bi-phone"></i>',
                //       name: "Tinjauan Aplikasi",
                //       value: gp.kmbFormatter(
                //         response.data.stats.review
                //           ? response.data.stats.review
                //           : 0
                //       ),
                //     });
                //   }
                // }

                this.data_sentimen = [
                  {
                    name: "Positif",
                    y: response.data.stats.positif,
                    color: "#28a745",
                    source: [
                      'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                    ]
                  },
                  {
                    name: "Netral",
                    y: response.data.stats.netral,
                    color: "#0e6d87AA",
                    source: [
                      'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                    ]
                  },
                  {
                    name: "Negatif",
                    y: response.data.stats.negatif,
                    color: $("body").css("--danger") + "AA",
                    source: [
                      'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                    ]
                  },
                ];

                this.data_sentimen_formed = [
                  {
                    name: "Positif",
                    y: response.data.stats_formed.positif,
                    color: $("body").css("--success") + "AA",
                    source: 'news'
                  },
                  {
                    name: "Netral",
                    y: response.data.stats_formed.netral,
                    color: "#0e6d87AA",
                    source: 'news'
                  },
                  {
                    name: "Negatif",
                    y: response.data.stats_formed.negatif,
                    color: $("body").css("--danger") + "AA",
                    source: 'news'
                  },
                ];

                if (this.sentimen_toggle == "medsos") {
                  this.data_sentimen_current = this.data_sentimen;
                } else {
                  this.data_sentimen_current = this.data_sentimen_formed;
                }

                this.data_sentimen_key++;

                total_sentimen =
                  response.data.stats.positif +
                  response.data.stats.netral +
                  response.data.stats.negatif;

                this.data_sentimen_persentase = {
                  positif:
                    response.data.stats.positif > 0
                      ? (response.data.stats.positif / total_sentimen) * 100
                      : 0,
                  negatif:
                    response.data.stats.negatif > 0
                      ? (response.data.stats.negatif / total_sentimen) * 100
                      : 0,
                  netral:
                    response.data.stats.netral > 0
                      ? (response.data.stats.netral / total_sentimen) * 100
                      : 0,
                };

                let total_sentimen =
                  response.data.stats_formed.positif +
                  response.data.stats_formed.netral +
                  response.data.stats_formed.negatif;

                this.data_sentimen_persentase_formed = {
                  positif:
                    response.data.stats_formed.positif > 0
                      ? (response.data.stats_formed.positif / total_sentimen) *
                      100
                      : 0,
                  negatif:
                    response.data.stats_formed.negatif > 0
                      ? (response.data.stats_formed.negatif / total_sentimen) *
                      100
                      : 0,
                  netral:
                    response.data.stats_formed.netral > 0
                      ? (response.data.stats_formed.netral / total_sentimen) *
                      100
                      : 0,
                };

                let data_topik_assemble = this.assembleDataGrafik(
                  response.data.bar_topik
                );
                this.data_topik_barchart = data_topik_assemble;

                data_topik_assemble = this.assembleDataGrafik(
                  response.data.bar_topik_formed
                );
                this.data_topik_barchart_formed = data_topik_assemble;

                if (this.topik_toggle == "medsos") {
                  if (this.data_topik_barchart) {
                    this.data_topik_barchart_current =
                      this.data_topik_barchart.grafik_data;
                    this.dt_body_current = this.data_topik_barchart.table_data;
                    this.data_topik = this.data_topik_barchart.data_topik;
                  }
                } else {
                  if (this.data_topik_barchart_formed) {
                    this.data_topik_barchart_current =
                      this.data_topik_barchart_formed.grafik_data;
                    this.dt_body_current =
                      this.data_topik_barchart_formed.table_data;
                    this.data_topik =
                      this.data_topik_barchart_formed.data_topik;
                  }
                }
                this.assembleBarchartDrilldown(
                  response.data.bar_grup_sentiment,
                  response.data.group_list,
                  response.data.bar_topik_formed,
                  response.data.grup_topic
                );
                this.scorecardMedkon(response.data.stats_formed);
                let media = this.activeChannel;
                let tren_medsos = {
                  x: [],
                  y: [],
                };
                tren_medsos.x = this.data_tren_medsos.x;
                if ("twitter" in media) {
                  if (media.twitter.status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[0]);
                  }
                }
                if ("facebook" in media) {
                  if (media.facebook.status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[1]);
                  }
                }
                if ("instagram" in media) {
                  if (media.instagram.status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[2]);
                  }
                }
                if ("youtube" in media) {
                  if (media.youtube.status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[3]);
                  }
                }
                if ("google" in media) {
                  if (media.google.forum_status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[4]);
                  }
                }
                // if ("google" in media) {
                //   if (media.google.blog_status == 1) {
                //     tren_medsos.y.push(this.data_tren_medsos.y[5]);
                //   }
                // }
                if ("linkedin" in media) {
                  if (media.linkedin.status == 1) {
                    tren_medsos.y.push(this.data_tren_medsos.y[6]);
                  }
                }
                if ("tiktok" in media) {
                  if (media.tiktok.status == 1) {
                    tren_medsos.y.push({
                      color: "#000000",
                      data: this.data_tren_medsos.y[7].data,
                      name: "Tiktok",
                    });
                  }
                }
                // if ("review" in media) {
                //   if (media.review.status == 1) {
                //     tren_medsos.y.push({
                //       color: "#000000",
                //       data: this.data_tren_medsos.y[8].data,
                //       name: "Tinjauan Aplikasi",
                //     });
                //   }
                // }
                let tren_medkon = {
                  x: [],
                  y: [],
                  yAxis: [],
                };
                tren_medkon.x = this.data_tren_formed.x;
                if ("google" in media) {
                  if (media.google.news_status == 1) {
                    tren_medkon.y.push(this.data_tren_formed.y[0]);
                  }
                }
                if ("formed" in media) {
                  if (media.formed.tv_status == 1) {
                    tren_medkon.y.push(this.data_tren_formed.y[1]);
                  }
                }
                if ("formed" in media) {
                  if (media.formed.cetak_status == 1) {
                    tren_medkon.y.push(this.data_tren_formed.y[2]);
                  }
                }
                tren_medkon.yAxis = this.data_tren_formed.yAxis;
                this.data_tren_grafik = {
                  data_tren_medsos: tren_medsos,
                  show_tren_reach: this.show_tren_reach,
                  data_tren_reach: this.data_tren_reach,
                  event_linechart_medsos: this.event_linechart_medsos,
                  display_tipe: this.display_tipe,
                  event_linechart_medkon: this.event_linechart_medkon,
                  data_tren_formed: tren_medkon,
                };

                this.data_count_source = {
                  data_source_list_formed: this.data_source_list_formed,
                  data_source_list: this.data_source_list,
                  is_mobile: this.is_mobile,
                };

                this.dashboard_data_sentimen = {
                  barchart_drilldown: this.barchart_drilldown,
                  barchart_drilldown_key: this.barchart_drilldown_key,
                  data_topik_barchart_current: this.data_topik_barchart_current,
                  data_topik: this.data_topik,
                  data_topik_key: this.data_topik_key,
                  dt_key: this.dt_key,
                  dt_head: this.dt_head,
                  dt_body_current: this.dt_body_current,
                  dt_config: this.dt_config,
                  data_sentimen_persentase_formed:
                    this.data_sentimen_persentase_formed,
                  data_sentimen_persentase: this.data_sentimen_persentase,
                  data_sentimen_current: this.data_sentimen_current,
                  data_sentimen_key: this.data_sentimen_key,
                  data_sentimen_formed: this.data_sentimen_formed,
                  data_sentimen: this.data_sentimen,
                  data_topik_medsos: this.data_topik_barchart,
                };
                this.data_topik_key++;
                this.barchart_drilldown_key++;
              } else if (this.display_tipe == 1) {
                this.dashboardMedsos(response.data);
              }
            } else {
              this.card = {
                formed: 0,
                medsos: 0,
                engagement: 0,
                reach: 0,
              };
              this.data_sentimen_current = null;
              this.data_sentimen_persentase = {
                positif: 0,
                negatif: 0,
                netral: 0,
              };
              this.data_sentimen_persentase_formed = {
                positif: 0,
                negatif: 0,
                netral: 0,
              };
              this.dt_body_current = [];
              this.data_source_list_formed = [
                {
                  id: "media_tv",
                  icon: '<i class="bi bi-tv"></i>',
                  name: "Media TV",
                  value: 0,
                },
                {
                  id: "media_cetak",
                  icon: '<i class="bi bi-newspaper icon-media-cetak"></i>',
                  name: "Media Cetak",
                  value: 0,
                },
                {
                  id: "news",
                  icon: '<i class="bi bi-globe-americas icon-news"></i>',
                  name: "Media Online",
                  value: 0,
                },
              ];

              this.data_source_list = [
                {
                  id: "facebook",
                  icon: '<i class="bi bi-facebook"></i>',
                  name: "Facebook",
                  value: 0,
                },
                {
                  id: "twitter",
                  icon: '<i class="bi bi-twitter-x"></i>',
                  name: "Twitter",
                  value: 0,
                },
                {
                  id: "instagram",
                  icon: '<i class="bi bi-instagram"></i>',
                  name: "Instagram",
                  value: 0,
                },
                {
                  id: "tiktok",
                  icon: '<i class="bi bi-tiktok"></i>',
                  name: "Tiktok",
                  value: 0,
                },
                {
                  id: "youtube",
                  icon: '<i class="bi bi-youtube"></i>',
                  name: "Youtube",
                  value: 0,
                },
                {
                  id: "linkedin",
                  icon: '<i class="bi bi-linkedin"></i>',
                  name: "Linkedin",
                  value: 0,
                },
                // {
                //   id: "blog",
                //   icon: '<i class="bi bi-rss"></i>',
                //   name: "Blog",
                //   value: 0,
                // },
                {
                  id: "forum",
                  icon: '<i class="bi bi-chat-dots-fill"></i>',
                  name: "Forum",
                  value: 0,
                },
                // {
                //   id: "review",
                //   icon: '<i class="bi bi-phone"></i>',
                //   name: "Tinjauan Aplikasi",
                //   value: 0,
                // },
              ];

              this.data_tren_grafik = {};
              this.data_count_source = {};
              this.dashboard_data_sentimen = {};
              this.data_sentimen_key++;
              this.data_topik_key++;
              this.dt_key++;
              this.barchart_drilldown_key++;
              this.dashboard_data_sentimen = {
                barchart_drilldown: {},
                barchart_drilldown_key: this.barchart_drilldown_key,
                data_topik_barchart_current: null,
                data_topik: {},
                data_topik_key: this.data_topik_key,
                dt_key: this.dt_key,
                dt_head: this.dt_head,
                dt_body_current: null,
                dt_config: this.dt_config,
                data_sentimen_persentase_formed:
                  this.data_sentimen_persentase_formed,
                data_sentimen_persentase: this.data_sentimen_persentase,
                data_sentimen_current: this.data_sentimen_current,
                data_sentimen_key: this.data_sentimen_key,
              };

              this.data_scorecard_medkon = {
                tv: "0",
                news: "0",
                mediacetak: "0",
              };
              this.data_scorecard_medsos.mention = 0;
              this.data_scorecard_medsos.reach = 0;
              this.data_scorecard_medsos.engagement = 0;
              this.data_scorecard_medsos.positif = 0;
              this.data_scorecard_medsos.netral = 0;
              this.data_scorecard_medsos.negatif = 0;

              this.data_scorecard_medsos.persentase = {
                positif: 0,
                netral: 0,
                negatif: 0,
              };
              let sources = [];
              sources["twitter"] = 0;
              sources["facebook"] = 0;
              sources["instagram"] = 0;
              sources["youtube"] = 0;
              sources["forum"] = 0;
              // sources["blog"] = 0;
              sources["review"] = 0;
              this.sources_medsos = sources;
              this.data_tren_medsos_kurasi = {};
              this.data_topik = {};
              this.data_topik_medsos = {};
              this.g_topik_key++;
              this.sources_key++;
              this.dashboard_sentimen_key++;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(function () {
            self.is_loading = false;
          });
      }
    },
    assembleDataGrafik: function (data_grafik) {
      if (data_grafik != null) {
        let selected_topic_key = null;
        let data_topik;
        if ("topic" in this.$route.query) {
          data_topik = [];
          for (let key in data_grafik.topics) {
            if (data_grafik.topics[key].id == this.$route.query.topic) {
              data_topik.push(data_grafik.topics[key]);
              selected_topic_key = key;
            }
          }
        } else {
          data_topik = data_grafik.topics;
        }

        let data_tabel = [];
        let data_bar_chart = [];
        let chart_values = {};
        let key_value = [];
        let obj_key_value = {};

        // whitelist data
        let key_grafik = ["positif", "negatif", "netral"];
        for (let obj_key in data_grafik) {
          if (obj_key == "topics") {
            for (let arr_key in data_grafik[obj_key]) {
              if (typeof data_tabel[arr_key] == "undefined") {
                data_tabel[arr_key] = [];
              }
              data_tabel[arr_key][0] = data_grafik[obj_key][arr_key].nama;
            }
          }
          if (key_grafik.includes(obj_key)) {
            key_value = [];
            for (let arr_key in data_grafik[obj_key]) {
              // ini set data buat tabel
              if (obj_key == "positif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][1] = data_grafik[obj_key][arr_key];
              }
              if (obj_key == "netral") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][2] = data_grafik[obj_key][arr_key];
              }
              if (obj_key == "negatif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][3] = data_grafik[obj_key][arr_key];
              }

              // set data untuk bar chart
              obj_key_value = {
                x: arr_key,
                y: data_grafik[obj_key][arr_key],
              };
              if (selected_topic_key != null) {
                if (selected_topic_key == arr_key) {
                  key_value.push(obj_key_value);
                }
              } else {
                key_value.push(obj_key_value);
              }
            }
            chart_values = {
              key: this.capitalizeWords(obj_key),
              values: key_value,
            };
            if (obj_key == "positif") data_bar_chart[0] = chart_values;
            if (obj_key == "netral") data_bar_chart[1] = chart_values;
            if (obj_key == "negatif") data_bar_chart[2] = chart_values;
          }
        }

        data_bar_chart.source = [
          'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
        ]
        return {
          table_data: data_tabel,
          grafik_data: data_bar_chart,
          data_topik: data_topik,
        };
      }
    },
    capitalizeWords: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getChannel();
          this.getNewsTrend();
        });
    },
    assembleBarchartDrilldown: function (
      dataset,
      data_grup,
      data_topic_trend,
      data_grup_topic
    ) {
      let data = [];
      let grup_data = [];
      for (let i = 0; i < dataset.length; i++) {
        var nama = "";
        var warna = "";
        if (dataset[i]["_id"] == 1) {
          nama = "Positif";
          warna = "#28a745";
        } else if (dataset[i]["_id"] == 0) {
          nama = "Netral";
          warna = "#17a2b8";
        } else if (dataset[i]["_id"] == -1) {
          nama = "Negatif";
          warna = "#dc3545";
        }
        grup_data = [];
        for (let j = 0; j < dataset[i].groups.length; j++) {
          if (dataset[i].groups[j].grup) {
            let res_grup = data_grup.find(
              (el) => el["_id"].$oid == dataset[i].groups[j].grup.$oid
            );
            if (res_grup) {
              grup_data.push({
                name: res_grup ? res_grup.group : "No Group",
                y: dataset[i].groups[j].count,
                drilldown: true,
              });
            }
          }
        }
        data.push({
          name: nama,
          data: grup_data,
          color: warna,
        });
      }

      let subseries = [];
      data_grup.forEach((element) => {
        subseries[element.group] = [
          {
            name: "Positif",
            color: "#28a745",
            data: [],
          },
          {
            name: "Netral",
            color: "#17a2b8",
            data: [],
          },
          {
            name: "Negatif",
            color: "#dc3545",
            data: [],
          },
        ];
      });

      if (data_topic_trend.topics.length > 0) {
        for (let i = 0; i < data_topic_trend.topics.length; i++) {
          let grup_id = data_grup_topic.find(
            (el) => el["_id"].$oid == data_topic_trend.topics[i].id
          );
          if (grup_id) {
            grup_id = grup_id.group_id.$oid;
            let grup_name = data_grup.find(
              (el) => el["_id"].$oid == grup_id
            ).group;
            subseries[grup_name][0].data.push([
              data_topic_trend.topics[i].nama,
              data_topic_trend.positif[i],
            ]);
            subseries[grup_name][1].data.push([
              data_topic_trend.topics[i].nama,
              data_topic_trend.netral[i],
            ]);
            subseries[grup_name][2].data.push([
              data_topic_trend.topics[i].nama,
              data_topic_trend.negatif[i],
            ]);
          }
        }
      }
      this.barchart_drilldown = {
        series: data,
        subseries: subseries,
        groups: data_grup,
      };
      this.barchart_drilldown_key++;
    },
    scorecardMedkon: function (data) {
      let sumTV = data.media_tv;
      let sumCetak = data.media_cetak;
      let sumNews = data.news;

      this.data_scorecard_medkon = {
        tv: sumTV,
        news: sumNews,
        mediacetak: sumCetak,
      };
    },
    dashboardMedsos: function (data) {
      this.data_scorecard_medsos = {};
      this.data_scorecard_medsos.mention = data.stats.total.toString();
      this.data_scorecard_medsos.reach = data.stats.esmr.toString();
      this.data_scorecard_medsos.engagement = data.stats.engagement.toString();
      this.data_scorecard_medsos.positif = data.stats.positif.toString();
      this.data_scorecard_medsos.netral = data.stats.netral.toString();
      this.data_scorecard_medsos.negatif = data.stats.negatif.toString();
      let total_sentimen =
        parseInt(this.data_scorecard_medsos.positif) +
        parseInt(this.data_scorecard_medsos.netral) +
        parseInt(this.data_scorecard_medsos.negatif);

      this.data_scorecard_medsos.persentase = {
        positif:
          total_sentimen > 0
            ? this.decimalFix(
              (this.data_scorecard_medsos.positif / total_sentimen) * 100
            )
              .toString()
              .replace(".", ",")
            : "0",
        netral:
          total_sentimen > 0
            ? this.decimalFix(
              (this.data_scorecard_medsos.netral / total_sentimen) * 100
            )
              .toString()
              .replace(".", ",")
            : "0",
        negatif:
          total_sentimen > 0
            ? this.decimalFix(
              (this.data_scorecard_medsos.negatif / total_sentimen) * 100
            )
              .toString()
              .replace(".", ",")
            : "0",
      };
      this.setSourceData(data);
      this.data_tren_medsos_kurasi = data.trend ? data.trend : {};
      this.data_topik_medsos = data.bar_topik;
      this.g_topik_key++;
      this.sources_key++;
    },
    setSourceData: function (data) {
      let sources = [];
      sources["twitter"] = data.stats.twitter;
      sources["facebook"] = data.stats.facebook;
      sources["instagram"] = data.stats.instagram;
      sources["youtube"] = data.stats.youtube;
      sources["forum"] = data.stats.forum;
      // sources["blog"] = data.stats.blog;
      sources["tiktok"] = data.stats.tiktok;
      sources["linkedin"] = data.stats.linkedin;
      sources["review"] = data.stats.review;
      this.sources_medsos = sources;
    },
    decimalFix: function (value) {
      return value.toFixed(2);
    },
    getNewsTrend: function () {
      if (this.news_trend > 0) {
        var temp_params = this.$route.query;
        let params = {
          from: temp_params.from,
          to: temp_params.to,
        };
        let query;
        if ("from" in params && "to" in params) {
          query = Object.keys(params)
            .map((key) => key + "=" + moment(params[key]).format("YYYY-MM-DD"))
            .join("&");
        }

        this.data_newstrend = [];

        let api =
          process.env.VUE_APP_API_URL +
          "newstrend/rank/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.data_newstrend = response.data.trend;
            } else {
              this.data_newstrend = [];
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.formattingBarChart();
            this.newstrendKey++;
          });
      }
    },
    formattingBarChart: function () {
      if (this.data_newstrend.length > 0) {
        let dataCategories = [];
        let dataSeries = [];
        let v_positif = [];
        let v_negatif = [];
        let v_netral = [];
        for (let index = 0; index < this.data_newstrend.length; index++) {
          dataCategories.push(this.data_newstrend[index].title);
          if ("negatif" in this.data_newstrend[index].sentimen) {
            v_negatif[index] = this.data_newstrend[index].sentimen.negatif;
          } else {
            v_negatif[index] = 0;
          }
          if ("netral" in this.data_newstrend[index].sentimen) {
            v_netral[index] = this.data_newstrend[index].sentimen.netral;
          } else {
            v_netral[index] = 0;
          }
          if ("positif" in this.data_newstrend[index].sentimen) {
            v_positif[index] = this.data_newstrend[index].sentimen.positif;
          } else {
            v_positif[index] = 0;
          }
        }
        dataSeries.push(
          {
            name: "Negatif",
            color: $("body").css("--danger") + "AA",
            data: v_negatif,
          },
          {
            name: "Netral",
            color: "#0e6d87AA",
            data: v_netral,
          },
          {
            name: "Positif",
            color: "#28a745",
            data: v_positif,
          }
        );
        this.barData = {
          dataCategories: dataCategories,
          dataSeries: dataSeries,
        };
      } else {
        this.barData = {
          dataCategories: [],
          dataSeries: [],
        };
      }
    },
    getChannel: function () {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      axios({ url: api, data: {}, method: "GET" })
        .then((response) => {
          this.activeChannel = response.data.project_detail.crawler;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getData();
        });
    },
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
  watch: {
    $route() {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (this.query != query && query != "") {
        this.is_loading = true;
        this.getChannel();
        this.getNewsTrend();
      }
    },
    sentimen_toggle() {
      if (this.sentimen_toggle == "medsos") {
        this.data_sentimen_current = this.data_sentimen;
      } else {
        this.data_sentimen_current = this.data_sentimen_formed;
      }
      this.data_sentimen_key++;
    },
    topik_toggle() {
      if (this.topik_toggle == "medsos") {
        if (this.data_topik_barchart) {
          this.data_topik_barchart_current =
            this.data_topik_barchart.grafik_data;
          this.dt_body_current = this.data_topik_barchart.table_data;
          this.data_topik = this.data_topik_barchart.data_topik;
        }
      } else {
        if (this.data_topik_barchart_formed) {
          this.data_topik_barchart_current =
            this.data_topik_barchart_formed.grafik_data;
          this.dt_body_current = this.data_topik_barchart_formed.table_data;
          this.data_topik = this.data_topik_barchart_formed.data_topik;
        }
      }
      this.data_topik_key++;
      this.dt_key++;
    },
  },
  mounted: function () {
    let v_step = [];
    if (this.display_tipe == 2) {
      v_step[0] = {
        target: "#page-header-validasi",
        header: {
          title: "Filter Validasi",
        },
        content: `Digunakan untuk memfilter data berdasarkan status validasi`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[1] = {
        target: "#page-header-select",
        header: {
          title: "Filter Topik",
        },
        content: `Digunakan untuk memfilter data berdasarkan topik`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[2] = {
        target: "#reportrange",
        header: {
          title: "Filter Periode",
        },
        content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[3] = {
        target: '[data-v-step="3"]',
        header: {
          title: "Jumlah Media Online",
        },
        content:
          "Jumlah  Media Online dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[4] = {
        target: '[data-v-step="1"]',
        header: {
          title: "Jumlah Media Cetak",
        },
        content:
          "Jumlah  Media Cetak yang masuk dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[5] = {
        target: '[data-v-step="2"]',
        header: {
          title: "Jumlah Media TV",
        },
        content:
          "Jumlah  Media TV dalam rentang waktu yang tertera pada filter periode",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };

      v_step[6] = {
        target: '[data-v-step="4"]',
        header: {
          title: "Data Tren Media Online",
        },
        content:
          "Grafik yang menunjukan tren setiap kanal media online dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      if (this.news_trend > 0) {
        v_step[7] = {
          target: '[data-v-step="5"]',
          header: {
            title: "Data News Trend",
          },
          content:
            "Grafik yang menunjukan News Tren dalam rentang waktu yang tertera pada filter periode.",
          params: {
            placement: "top",
            enableScrolling: false,
          },
        };
      }
      v_step[this.news_trend > 0 ? 8 : 7] = {
        target: '[data-v-step="6"]',
        header: {
          title: "Data Persentase Sentimen Posting",
        },
        content:
          "Grafik yang menunjukan Persentase Sentimen Posting dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[this.news_trend > 0 ? 9 : 8] = {
        target: '[data-v-step="7"]',
        header: {
          title: "Data Sentimen Posting per Topik",
        },
        content:
          "Grafik yang menunjukan Sentimen Posting per Topik dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[this.news_trend > 0 ? 10 : 9] = {
        target: '[data-v-step="8"]',
        header: {
          title: "Mention Terpopuler",
        },
        content:
          "Menampilkan mention terpopuler dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[this.news_trend > 0 ? 11 : 10] = {
        target: '[data-v-step="9"]',
        header: {
          title: "Mention Terbaru",
        },
        content:
          "Menampilkan mention terbaru dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
    } else if (this.display_tipe == 1) {
      v_step[0] = {
        target: "#page-header-validasi",
        header: {
          title: "Filter Validasi",
        },
        content: `Digunakan untuk memfilter data berdasarkan status validasi`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[1] = {
        target: "#page-header-select",
        header: {
          title: "Filter Topik",
        },
        content: `Digunakan untuk memfilter data berdasarkan topik`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[2] = {
        target: "#reportrange",
        header: {
          title: "Filter Periode",
        },
        content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[3] = {
        target: '[data-v-step="1"]',
        header: {
          title: "Jumlah Mention",
        },
        content:
          "Menampilkan jumlah mention dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[4] = {
        target: '[data-v-step="2"]',
        header: {
          title: "Jumlah Reach",
        },
        content:
          "Menampilkan jumlah reach dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[5] = {
        target: '[data-v-step="3"]',
        header: {
          title: "Jumlah Engagement",
        },
        content:
          "Menampilkan jumlah engagement dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[6] = {
        target: '[data-v-step="4"]',
        header: {
          title: "Jumlah Sentiment Positive",
        },
        content:
          "Menampilkan jumlah Sentiment Positive dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[7] = {
        target: '[data-v-step="5"]',
        header: {
          title: "Jumlah Sentiment Netral",
        },
        content:
          "Menampilkan jumlah Sentiment Netral dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[8] = {
        target: '[data-v-step="6"]',
        header: {
          title: "Jumlah Sentiment Negative",
        },
        content:
          "Menampilkan jumlah Sentiment Negative dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[9] = {
        target: '[data-v-step="7"]',
        header: {
          title: "Grafik Tren Mention, Reach dan Engagement",
        },
        content:
          "Menampilkan Grafik Tren Mention, Reach dan Engagement dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[10] = {
        target: '[data-v-step="8"]',
        header: {
          title: "Sources",
        },
        content:
          "Menampilkan jumlah Tren Sources dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[11] = {
        target: '[data-v-step="9"]',
        header: {
          title: "Sentimen",
        },
        content:
          "Menampilkan komparasi sentimen  dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[12] = {
        target: '[data-v-step="10"]',
        header: {
          title: "Posting",
        },
        content:
          "Menampilkan Posting Terbaru dan Terpopuler dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
    } else if (this.display_tipe == 3) {
      v_step[0] = {
        target: "#page-header-validasi",
        header: {
          title: "Filter Validasi",
        },
        content: `Digunakan untuk memfilter data berdasarkan status validasi`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[1] = {
        target: "#page-header-select",
        header: {
          title: "Filter Topik",
        },
        content: `Digunakan untuk memfilter data berdasarkan topik`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[2] = {
        target: "#reportrange",
        header: {
          title: "Filter Periode",
        },
        content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };

      v_step[3] = {
        target: '[data-v-step="1"]',
        header: {
          title: "Jumlah Media Konvesional",
        },
        content:
          "Menampilkan jumlah Media Konvesional dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[4] = {
        target: '[data-v-step="2"]',
        header: {
          title: "Jumlah Media Sosial",
        },
        content:
          "Menampilkan jumlah Media Sosisal dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[5] = {
        target: '[data-v-step="3"]',
        header: {
          title: "Jumlah Engagement",
        },
        content:
          "Menampilkan jumlah Engagement dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[6] = {
        target: '[data-v-step="4"]',
        header: {
          title: "Jumlah Reach",
        },
        content:
          "Menampilkan jumlah reach dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[7] = {
        target: "#db-tren-medkon",
        header: {
          title: "Data Tren Media Online",
        },
        content:
          "Grafik yang menunjukan data tren media online dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[8] = {
        target: "#db-tren-medsos",
        header: {
          title: "Data Tren Media Sosial",
        },
        content:
          "Grafik yang menunjukan data tren media sosial dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[9] = {
        target: "#countSource",
        header: {
          title: "Data Jumlah Medkon dan Medsos",
        },
        content:
          "Menampilkan jumlah data medkon dan medsos  rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      // v_step[10] = {
      //   target: "#db-newstrend",
      //   header: {
      //     title: "Data News Trend",
      //   },
      //   content:
      //     "Grafik yang menunjukan News Tren dalam rentang waktu yang tertera pada filter periode.",
      //   params: {
      //     placement: "top",
      //     enableScrolling: false,
      //   },
      // };
      v_step[10] = {
        target: "#db-persentase-sentimen",
        header: {
          title: "Data Presentase Posting",
        },
        content:
          "Menampilkan presentase posting dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[11] = {
        target: "#db-data-persentase",
        header: {
          title: "Data Sentimen Posting",
        },
        content:
          "Menampilkan grafik sentimen posting per topik dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[12] = {
        target: "#postMediaKon",
        header: {
          title: "Mention Terpopuler",
        },
        content:
          "Menampilkan Postingan Media Online Terpopuler dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
      v_step[13] = {
        target: "#postMedsos",
        header: {
          title: "Postingan Media Sosial",
        },
        content:
          "Menampilkan Postingan Media Sosial Terpopuler dalam rentang waktu yang tertera pada filter periode.",
        params: {
          placement: "top",
          enableScrolling: false,
        },
      };
    }
    this.tour_steps = v_step;
    this.getTopic();
    this.mounted = true;
  },
};
</script>

<style>
.bg-white {
  background-color: white;
}

.subscribe-overlay {
  position: absolute;
  z-index: 1;
  background: #ffffffec;
  width: 95%;
  color: #0000004f;
}
</style>
